// Maps legacy column field names to new unified view field names
const COLUMN_FIELD_MAPPINGS = {
    billing_status_state_pause_automated_billing_evaluation_reason_code: 'pause_automated_billing_evaluation_reason_code',
    billing_status_state_pause_automated_billing_evaluation_reason_codes: 'pause_automated_billing_evaluation_reason_codes',
    billing_status_state_has_pending_shipper_accessorials_or_unbilled_receivables_charge: 'has_pending_shipper_unbilled_charge',
    pending_shipper_accessorials_and_unbilled_receivables_charge_total: 'pending_shipper_unbilled_total',
    billing_status_state_pause_automated_billing_evaluation_timestamp: 'pause_automated_billing_evaluation_timestamp',
};
function mapColumnField(columnDef) {
    const mapped = Object.assign({}, columnDef);
    if (mapped.field && COLUMN_FIELD_MAPPINGS[mapped.field]) {
        mapped.field = COLUMN_FIELD_MAPPINGS[mapped.field];
    }
    if (Array.isArray(mapped.children)) {
        mapped.children = mapped.children.map(mapColumnField);
    }
    return mapped;
}
// Coalesce legacy/new column defs to use new fields when enabled
export function coalesceColumnDefs(columnDefs = []) {
    if (!Array.isArray(columnDefs))
        return columnDefs;
    return columnDefs.map(mapColumnField);
}
export default coalesceColumnDefs;
